var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.646894 0.646894C0.69334 0.60033 0.748515 0.563387 0.80926 0.538181C0.870005 0.512974 0.935127 0.5 1.00089 0.5C1.06666 0.5 1.13178 0.512974 1.19253 0.538181C1.25327 0.563387 1.30845 0.60033 1.35489 0.646894L7.00089 6.29389L12.6469 0.646894C12.6934 0.600406 12.7486 0.563529 12.8093 0.53837C12.87 0.513211 12.9352 0.500262 13.0009 0.500262C13.0666 0.500262 13.1317 0.513211 13.1925 0.53837C13.2532 0.563529 13.3084 0.600406 13.3549 0.646894C13.4014 0.693381 13.4383 0.748571 13.4634 0.80931C13.4886 0.870049 13.5015 0.93515 13.5015 1.00089C13.5015 1.06664 13.4886 1.13174 13.4634 1.19248C13.4383 1.25322 13.4014 1.30841 13.3549 1.35489L7.35489 7.35489C7.30845 7.40146 7.25327 7.4384 7.19253 7.46361C7.13178 7.48881 7.06666 7.50179 7.00089 7.50179C6.93513 7.50179 6.87001 7.48881 6.80926 7.46361C6.74852 7.4384 6.69334 7.40146 6.64689 7.35489L0.646894 1.35489C0.600331 1.30845 0.563388 1.25327 0.538181 1.19253C0.512975 1.13178 0.5 1.06666 0.5 1.00089C0.5 0.935126 0.512975 0.870005 0.538181 0.80926C0.563388 0.748515 0.600331 0.693339 0.646894 0.646894Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownMenuIcon);
export default __webpack_public_path__ + "static/media/arrow-down-menu-icon.4be2835cf650712125a1dcde909da97f.svg";
export { ForwardRef as ReactComponent };